import React from "react";
import shape6 from "../../images/shape-6.png";
import shape24 from "../../images/shape-24.png";
import shape23 from "../../images/shape-23.png";
import shape5 from "../../images/shape-5.png";
import shape8 from "../../images/shape-8.png";
import author from "../../images/author-03.jpg";
import course from "../../images/course.jpeg";
import course1 from "../../images/course.jpeg";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
const Courses = () => {
  const [show, setShow] = useState(false);
  function getShow(){
    setShow(true)
  }
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  let { id } = useParams();
  // console.log(id);
  const navigate = useNavigate();
  const [Branchget, setBranchget] = useState([]);
  const [ids, setids] = useState([]);
 function getVerify(s){
  var inputVal = document.getElementById("myInput").value;
  axios
  .patch(
    `https://maps-medics-be.onrender.com/use_permission/${inputVal}/${sessionStorage.getItem('user_id')}`,
  )
  
  .then((res) => {
    if (res.data.success) {
      console.log(res.data);
      navigate('/courseDetails/'+ sessionStorage.getItem('cource_id') );
    } else {
      throw new Error("Verification failed");
    }
  })
  .catch((err) => {
    console.error(err);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Verification failed!",
      // footer: '<a href="">Why do I have this issue?</a>',
    });    // navigate('/login');
  });
}
  function Nav(s) {
    console.log("omar sameh")
    handleShow()
    setids(s.id);
    // navigate("/courseDetails/"+s)
    // navigate("/login");
    sessionStorage.setItem("cource_id", s.id);
    // sessionStorage.setItem('loggedIn', true); 
    // Set the user's login status to true in local storage
    if(sessionStorage.getItem('loggedIn')){
      if (sessionStorage.getItem('cource_id' ) && s.enrolled === true) {
        navigate('/courseDetails/'+ sessionStorage.getItem('cource_id') )
        // Check if the user is logged in and has a course ID set in local storage
        console.log(s.name)
  //
        // navigate('/courseDetails/'+ sessionStorage.getItem('cource_id')+ '/' + s.name ) ;
        // console.log('amjod')
      } else {
      
     
     getShow();
       
        // navigate('/login'); // If the user is not logged in or does not have a course ID set, redirect to the login page
        // console.log('dav')
  
      }
    }
    else{
      navigate('/login');
    }
    
  }
  function startLearning(s) {
    console.log("omar sameh")
    setids(s.id);
    // navigate("/courseDetails/"+s)
    // navigate("/login");
    sessionStorage.setItem("cource_id", s.id);
    // sessionStorage.setItem('loggedIn', true); 
    // Set the user's login status to true in local storage
    if (sessionStorage.getItem('cource_id' , s.id)) {
      // Check if the user is logged in and has a course ID set in local storage
      console.log(s.name)
      navigate('/adver/'+ sessionStorage.getItem('cource_id')) ;
      // console.log('amjod')
    } else {
      navigate('/login'); // If the user is not logged in or does not have a course ID set, redirect to the login page
      // console.log('dav')

    }
  }
  console.log(ids);
  async function getBranchget() {
    let { data } = await axios.post(
      `https://maps-medics-be.onrender.com/show_all_cources`, sessionStorage.getItem('user_id')?{student_id:  sessionStorage.getItem('user_id')}: {}
    );
    setBranchget(data.result);
    console.log(data.result);
  }

  // let currentIndex = 0;
  // console.log(lightContainer);
  useEffect(() => {
    getBranchget();
  }, []);
  function showImage(x) {
    document
      .querySelector(".lightContainer")
      .classList.replace("d-none", "d-flex");
    // console.log("ayhagaaasa")
    //   document.querySelector(".lightBox").classList.replace("d-none", "d-flex");
    //   currentIndex = x.id;
    //  console.log(currentIndex)
  }
  function closeSlide() {
    document
      .querySelector(".lightContainer")
      .classList.replace("d-flex", "d-none");
  }
  const formatDuration = (durationInSeconds) => {
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = durationInSeconds % 60;

    const formattedDuration = [];
    if (hours > 0) {
      formattedDuration.push(`${hours}h`);
    }
    if (minutes > 0) {
      formattedDuration.push(`${minutes}m`);
    }
    if (seconds > 0) {
      formattedDuration.push(`${seconds}s`);
    }

    return formattedDuration.join(" ");
  };

  return (
    <>
    {/* <Navbar/> */}
    <Modal show={show} onHide={handleClose} className='alretCourse' style={{display:'flex', justifyContent:'center' , alignItems:'center'}}>
<Modal.Header closeButton>
  <Modal.Title>Please Enter The Verification code!</Modal.Title>
</Modal.Header>
<Modal.Body>
  <Form>
    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
      <Form.Label>Enter Verification Code</Form.Label>
      <Form.Control
        type="text"
        autoFocus
        id="myInput"
      />
    </Form.Group>
 
  </Form>
</Modal.Body>
<Modal.Footer>

  <Button variant="primary" onClick={getVerify} style={{backgroundColor:'#ffc600' , border:'1px solid #ffc600'}}>
    Submit
  </Button>
</Modal.Footer>
</Modal> 
    <div className="section " ></div>

      <div class="section page-banner">

      <div style={{backgroundColor:'rgba(0,0,0,0.4)', width:'100%', height:'100%',display:'flex', justifyContent:'center', alignItems:'center'}}>

        <div class="container" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
          <div class="page-banner-content">
           
            <h2 class="title" style={{color:'#fff'}}>
              Our <span>Courses.</span>
            </h2>
          </div>
        </div>

        </div>
      </div>
      <div class="section section-padding">
        <div class="container">
          <div class="courses-wrapper-02">
            <div class="row">
              {/* <div class="col-lg-12 col-md-6 p-3">
                            <div class="single-courses row">
                                <div class="courses-images col-md-4">
                                    <a href="courses-details.html"><img src={course} alt="Courses"/></a>

                                    <div class="courses-option dropdown">
                                        <button class="option-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </button>
                                        <ul class="dropdown-menu">
                                            <li><a href="#"><i class="icofont-share-alt"></i> Share</a></li>
                                            <li><a href="#"><i class="icofont-plus"></i> Create Collection</a></li>
                                            <li><a href="#"><i class="icofont-star"></i> Favorite</a></li>
                                            <li><a href="#"><i class="icofont-archive"></i> Archive</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="courses-content col-md-8">
                                  

                                    <h2 class="title">USMLE Step 1 Preparatory Course</h2>
                                    <div class="courses-rating">
                                        <p>By elmorshdy</p>

                                        <div class="rating-progress-bar">
                                        </div>

                                        <div class="rating-meta">
                                        
                                        <i  class="fa-solid fa-star" style={{color:'#FFC600', fontize: '14px',  letterSpacing: '2px'}}></i> 
                                           <i  class="fa-solid fa-star" style={{color:'#FFC600', fontize: '14px',  letterSpacing: '2px'}}></i>
                                           <i  class="fa-solid fa-star" style={{color:'#FFC600', fontize: '14px',  letterSpacing: '2px'}}></i>
                                           <i  class="fa-solid fa-star" style={{color:'#FFC600', fontize: '14px',  letterSpacing: '2px'}}></i>
                                           <i  class="fa-solid fa-star" style={{color:'#FFC600', fontize: '14px',  letterSpacing: '2px'}}></i>

                                            <p>Your rating</p>
                                        </div>
                                        <h6 style={{fontWeight:'bold'}}>10,000EGP</h6>
                                        <button class="btn btn-primary "                 onClick={() => showImage()}
 style={{backgroundColor:'#FFC600', border:'#FFC600'}}>Add To Cart <i class="fa-solid fa-cart-shopping"></i></button>

                                    </div>
                                </div>
                            </div>
                        </div> */}
              <div class="col-lg-12 col-md-6 p-3">
                {Branchget.map((p, index) => (
                  <div class="single-courses row m-2" value={p.id} key={index}>

{/* {p.enrolled=== true ?(
        navigate('/courseDetails/'+ sessionStorage.getItem('cource_id')+ '/' + p.name )

):
(<Modal show={show} onHide={handleClose} className='alretCourse' style={{display:'flex', justifyContent:'center' , alignItems:'center'}}>
<Modal.Header closeButton>
  <Modal.Title>Please Enter The Verification code!</Modal.Title>
</Modal.Header>
<Modal.Body>
  <Form>
    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
      <Form.Label>Enter Verification Code</Form.Label>
      <Form.Control
        type="text"
        autoFocus
        id="myInput"
      />
    </Form.Group>
 
  </Form>
</Modal.Body>
<Modal.Footer>

  <Button variant="primary" onClick={getVerify} style={{backgroundColor:'#ffc600' , border:'1px solid #ffc600'}}>
    Submit
  </Button>
</Modal.Footer>
</Modal> )
} */}

                    <div class="courses-images col-md-4">
                    <a 
                    //  onClick={() => startLearning(p)}
                     onClick={() => Nav(p)}
                    style={{textDecoration:'none', color:'#000'}}>
  <a>
                        <img src={p.image} alt="Courses" />
                      </a></a>
{/* <span className="badger"></span> */}
                      {/* <div class="courses-option dropdown">
                        <button
                          class="option-toggle"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span></span>
                          <span></span>
                          <span></span>
                        </button>
                        <ul class="dropdown-menu">
                          <li>
                            <a href="#">
                              <i class="icofont-share-alt"></i> Share
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i class="icofont-plus"></i> Create Collection
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i class="icofont-star"></i> Favorite
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i class="icofont-archive"></i> Archive
                            </a>
                          </li>
                        </ul>
                      </div> */}
                    </div>
                    <div class="courses-content col-md-8">
                      <div className="row">
                        <div className="col-md-2" style={{display:'flex', alignItems:'center'}}>
                        <div  className="courseCategories">
<div className="usmle">{p.name}</div>
                      </div> 
                        </div>
                        <div className="col-md-10" style={{display:'flex', alignItems:'center'}}><p style={{color:'#059de9', fontSize:'14px', fontFamily:'Poppins', fontWeight:'300'}}> {p.instructor}</p></div>
                      </div>
                                            

                      <div className="courseInstructor">
                        
                      </div>
                      {/* <h3  style={{fontSize:'18px', fontWeight:'600', lineHeight:'24px', color:'#333', fontFamily:'Playfair Display', textAlign:'center'}}></h3> */}
                      <div className="row  p-2">
                        <div className="col">
                        <i class="fa-solid fa-clock" style={{color:'#ffc600'}}></i> {formatDuration(p.hours)}
                        </div>
                        {/* <div className="col">
                   <i class="fa-solid fa-chart-simple" style={{color:'#ffc600'}}></i> Step 1
                        </div> */}
                        <div className="col">
                           <i class="fa-solid fa-clone" style={{color:'#ffc600'}}></i> {p.lessons} Lecture
                        </div>
                        {/* <div className="col">
                        <i class="fa-solid fa-puzzle-piece" style={{color:'#ffc600'}}></i> 20 Quizzes
                        </div> */}
                        {/* <div className="col">
                       <i class="fa-solid fa-user-graduate" style={{color:'#ffc600'}}></i> 65 Students
                        </div> */}
                      </div>
                      <div className="row p-2">
                        <p style={{marginBottom:'20px', color:'#666', fontSize:'16px', fontWeight:'300', lineHeight:'26px', fontFamily:'Poppins'}}>{p.description}</p>
                      </div>
     

                      
{/* 
                        <div class="rating-meta">
                          <i
                            class="fa-solid fa-star"
                            style={{
                              color: "#FFC600",
                              fontize: "14px",
                              letterSpacing: "2px",
                            }}
                          ></i>
                          <i
                            class="fa-solid fa-star"
                            style={{
                              color: "#FFC600",
                              fontize: "14px",
                              letterSpacing: "2px",
                            }}
                          ></i>
                          <i
                            class="fa-solid fa-star"
                            style={{
                              color: "#FFC600",
                              fontize: "14px",
                              letterSpacing: "2px",
                            }}
                          ></i>
                          <i
                            class="fa-solid fa-star"
                            style={{
                              color: "#FFC600",
                              fontize: "14px",
                              letterSpacing: "2px",
                            }}
                          ></i>
                          <i
                            class="fa-solid fa-star"
                            style={{
                              color: "#FFC600",
                              fontize: "14px",
                              letterSpacing: "2px",
                            }}
                          ></i>
                        </div> */}
                        <div className="row p-2">
                          <div className="col-md-3">
                          <h6 style={{ fontWeight: "bold" }}>{p.enrolled=== true? '' : p.price +'EGP'} </h6>

                          </div>
                          <div className="col-md-6"></div>
<div className="col-md-3" style={{float:'right'}}>
<button
  class="btn btn-primary "
  //  onClick={() => showImage()}
  style={{
    backgroundColor: "#FFC600",
    border: "#FFC600",
  }}
  // onClick={handleShow}
  onClick={() => Nav(p)}
>
Start Learning
<i class="fa-solid fa-book-open" style={{marginLeft:'5px'}}></i>
</button>  
</div>

                        </div>
                      
                     
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
 
      {/* <Footer/> */}
    </>
  );
};

export default Courses;
